module.exports = __webpack_public_path__ + "static/media/logo.726a2e11.svg";